module.exports = {

  prepareHtmlLoad (elemId, url) {
    return function () {
      $.get(url, (data) => $(elemId).html(data));
    };
  },

  prepareWidget (elemId, widget, options) {
    return function () {
      $(elemId)[widget](options);
    };
  }

};








// WEBPACK FOOTER //
// ./src/js/homepage/helpers.js